<ion-content>
    <div>
        <p>Need Special Dates?</p>
        <a [href]="hostLink" target="_blank" class="link">Contact Info</a>
    </div>
</ion-content>